import { ACTION_VARIANT, DataType, IWidget } from "../../types";
import { DOM } from "../../utils/domActions";
import Button from "../../components/Button";
import { TrackingUtil } from "../../utils/tracking";

class Banner implements IWidget {
    container: HTMLElement | null = document.querySelector(
        "#trustshop-embed-banner--container"
    );
    cardData: Partial<DataType> = {};
    campaignId: string | null = null;

    render(): HTMLElement {
        if (!this.container) {
            this.container = DOM.createElement("div", {
                id: "trustshop-embed-banner--container",
                className: "trustshop-embed-banner--container trustshop-embed--card",
            });
        }

        const bannerWrap = DOM.createElement("div", {
            className: "trustshop-embed-banner--wrap",
        });

        if (this.cardData.img_url) {
            bannerWrap.innerHTML = `<div class="trustshop-embed-banner--img"><img src="${this.cardData.img_url}" alt="Banner image"/></div>`;
        }

        const bannerContent = DOM.createElement("div", {
            className: "trustshop-embed-banner--content",
        });

        if (this.cardData.title) {
            bannerContent.innerHTML = `<p class="trustshop-embed-banner--title">${this.cardData.title}</p>`;
        }

        if (this.cardData.description) {
            bannerContent.innerHTML += `<p class="trustshop-embed-banner--description">${this.cardData.description}</p>`;
        }

        if (this.cardData.primary_action || this.cardData.secondary_actions) {
            const cardFooter = DOM.createElement("div", {
                className: "trustshop-embed-card--content-footer",
            });

            if (this.cardData.primary_action) {
                // Primary action defaults to "primary" variant if not specified
                const variant =
                    this.cardData.primary_action.variant ||
                    ACTION_VARIANT.PRIMARY;

                const cardAction = Button.create({
                    ...this.cardData.primary_action,
                    variant: variant,
                    campaignId: this.campaignId || undefined
                });

                cardFooter.appendChild(cardAction);
            }

            if (this.cardData.secondary_actions) {
                // Handle secondary actions (can be single or array)
                const secondaryActions = Array.isArray(
                    this.cardData.secondary_actions
                )
                    ? this.cardData.secondary_actions
                    : [this.cardData.secondary_actions];

                secondaryActions.forEach((action) => {
                    const actionElement = Button.create({
                        ...action,
                        campaignId: this.campaignId || undefined
                    });
                    cardFooter.appendChild(actionElement);
                });
            }
            bannerContent.appendChild(cardFooter);
        }

        const closeBtn = Button.createClose({
            className: "trustshop-embed-card--close",
            onClick: () => {
                this.destroy();
            },
        });

        bannerWrap.appendChild(bannerContent);
        bannerWrap.appendChild(closeBtn);
        this.container.appendChild(bannerWrap);
        document.body.appendChild(this.container);
        
        // Track view when banner is successfully rendered
        TrackingUtil.trackView(this.campaignId);
        
        return this.container;
    }

    show(): void {}
    hide(): void {}
    toggle(): void {}
    destroy(): void {
        this.cardData = {};
        if (this.container) {
            this.container.remove();
        }
    }
    updateData(data: any): void {
        this.cardData = {
            ...this.cardData,
            ...data,
        };
        
        // Get campaign ID from data
        if (data.id) {
            this.campaignId = String(data.id);
        }
    }

    isVisible(): boolean {
        throw new Error("Method not implemented.");
    }
}

const BannerInstance = new Banner();

export default BannerInstance;
